import { h } from 'vue'
import { CFormSelect } from '@coreui/vue'

// CFormSelect CoreUI memancarkan change sebelum update:modelValue, sehingga handler @change membaca nilai
// v-model yang lama. Pembungkus ini membalik urutannya; didaftarkan global menggantikan aslinya di main.js.
export default {
  name: 'CFormSelect',
  inheritAttrs: false,
  emits: ['change', 'update:modelValue'],
  setup(_, { attrs, slots, emit }) {
    let perubahan = null
    return () =>
      h(
        CFormSelect,
        {
          ...attrs,
          onChange: (event) => {
            perubahan = event
          },
          'onUpdate:modelValue': (nilai) => {
            emit('update:modelValue', nilai)
            emit('change', perubahan)
          },
        },
        slots,
      )
  },
}
